import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/Button';
import { MnemonicGrid } from '@/components/MnemonicGrid';
import { container } from '@/services/container';
import { useUiStore } from '@/store/ui';
import { MeshLinkError } from '@/lib/result';

/** 创建身份：生成 12 词助记词（全程无网络请求）。 */
export function CreateIdentityPage(): JSX.Element {
  const navigate = useNavigate();
  const pushError = useUiStore((s) => s.pushError);
  const [words, setWords] = useState<string[]>([]);
  const [copiedConfirmed, setCopiedConfirmed] = useState(false);

  useEffect(() => {
    try {
      const { words: generated } = container.identity.createIdentity();
      setWords(generated);
    } catch (err) {
      pushError(err instanceof MeshLinkError ? err.code : 'E_UNKNOWN');
    }
  }, [pushError]);

  return (
    <div className="flex min-h-full items-center justify-center p-6">
      <div className="card w-[min(92vw,520px)] p-6">
        <h1 className="text-lg font-semibold text-text">备份你的助记词</h1>
        <p className="mt-1 text-sm text-dim">
          这 12 个词就是你的身份。请按顺序抄写在纸上，并存放在只有你知道的地方。
        </p>

        <div className="mt-5">
          {words.length > 0 ? (
            <MnemonicGrid words={words} copyable={false} />
          ) : (
            <div className="h-[180px] animate-pulse rounded-card bg-panel-2" />
          )}
        </div>

        <label className="mt-5 flex items-start gap-2 text-xs text-dim">
          <input
            type="checkbox"
            className="mt-0.5"
            checked={copiedConfirmed}
            onChange={(e) => setCopiedConfirmed(e.target.checked)}
          />
          <span>我已按顺序抄写完成，并理解丢失助记词将无法找回账号。</span>
        </label>

        <div className="mt-5 flex justify-between gap-2">
          <Button variant="ghost" onClick={() => navigate('/welcome')}>
            返回
          </Button>
          <Button
            disabled={words.length === 0 || !copiedConfirmed}
            onClick={() => navigate('/backup', { state: { words } })}
          >
            下一步：验证助记词
          </Button>
        </div>
      </div>
    </div>
  );
}

export default CreateIdentityPage;
